import { render, staticRenderFns } from "./AppsDashboard.vue?vue&type=template&id=4bc55fff&"
import script from "./AppsDashboard.vue?vue&type=script&lang=js&"
export * from "./AppsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports